import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, List, Card, Button, message, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import _ from 'lodash';
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST, GOOGLE_MAP_KEY } from '../../configs/env';
import whttp from '../../libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper';
import classnames from 'classnames';
import { __ } from '@wordpress/i18n';

const VC_CONFIG = _.get(window, 'VC_CONFIG');

const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');
const stringToBr = (text) => {
  return _.map(_.split(text, '\n'), (line, idx) => (
    <Fragment key={idx}>
      {line}
      <br />
    </Fragment>
  ));
};
// 前端頁面
export default class RepairInfo extends Component {
  formRef = React.createRef();

  state = {
    tabType: 'info',
    listInfo: null,
    repairInfo: null,
    query: { sno: null, phone: null },
  };

  componentDidMount() {
    this.setState({
      tabType: AppHelper.getHashValue('tab') || 'info',
    });
    this.isFromThemePage();
    // this.formRef.current.setFieldsValue({ sno: 'TM20191022004' })
  }

  loadListData = (query) => {
    this.setState({
      isFetchData: true,
      listInfo: null,
      repairInfo: null,
    });

    whttp.get(
      API_HOST + `/api/repair/query`,
      {
        sno: _.get(query, 'sno'),
        phone: _.get(query, 'phone'),
      },
      (state, res) => {
        this.setState({ isFetchData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false || code !== 200) {
          message.warning(reason);
          return;
        }

        const cecRepairList = _.get(data, 'cec', []);
        const carrefourRepairList = _.get(data, 'carrefour', []);
        const repairList = _.isEmpty(cecRepairList) ? carrefourRepairList : cecRepairList;

        this.setState({ listInfo: repairList });
      }
    );
  };
  isFromThemePage = () => {
    const isFromPage = window.location.href;
    if (isFromPage.indexOf('?') != -1) {
      var ary1 = isFromPage.split('?');
      var ary2 = ary1[1].split('=');
      var ary3 = ary2[1].split('/');
      const type = ary2[0];
      const number = ary3[0];

      if (type === 'SN_NO') {
        const query = { sno: number, phone: null };
        this.formRef.current.setFieldsValue(query);
        this.formRef.current.submit();
      } else if (type === 'Phone') {
        const query = { sno: null, phone: number };
        this.formRef.current.setFieldsValue(query);
        this.formRef.current.submit();
      }
    }
  };
  formValidator = (rule, value) => {
    if (['sno', 'phone'].indexOf(rule.field) !== -1) {
      if (
        _.isEmpty(this.formRef.current.getFieldValue('sno')) &&
        _.isEmpty(this.formRef.current.getFieldValue('phone'))
      ) {
        return Promise.reject('ERROR');
      }
    }
    return Promise.resolve();
  };
  render() {
    const listInfo = _.get(this, 'state.listInfo');

    return (
      <Fragment>
        <main class='bg-light'>
          <div class='container'>
            <div class='row mb-5 pt-5'>
              <div class='col-8 col-md-2 mx-auto'>
                <img
                  class='img-contain'
                  src={`${PLUGIN_ASSETS_URL}img/maintain/web_search.svg`}
                  alt=''
                />
              </div>
            </div>
            <h4 class='heading-title align-items-center'>
              {__('維修紀錄查詢', 'cec-plugin-stores')}
            </h4>
            <hr class='border-top border-gray mt-0 mb-5' />
            <Form
              noStyle
              ref={this.formRef}
              name='basic'
              layout='vertical'
              onFinish={(values) => this.loadListData(values)}
              initialValues={this.state.query}>
              <p class='p text-muted text-center mb-5' style={{ fontSize: '16px' }}>
                {__('請輸入維修單號或電話號碼查詢', 'cec-plugin-stores')}
              </p>
              <div class='row justify-content-center'>
                <div class='col-sm-3'>
                  <Form.Item
                    {...genFormItemAtrribute('sno')}
                    dependencies={['sno']}
                    rules={[
                      {
                        validator: this.formValidator,
                        message: '請輸入維修單號',
                      },
                    ]}>
                    <Input
                      className='form-control'
                      style={{ fontSize: '16px' }}
                      placeholder='請輸入維修單號'
                    />
                  </Form.Item>
                </div>
                <div class='col-sm-3'>
                  <Form.Item
                    {...genFormItemAtrribute('phone')}
                    dependencies={['phone']}
                    rules={[
                      {
                        validator: this.formValidator,
                        message: '請輸入電話號碼查詢',
                      },
                    ]}>
                    <Input
                      className='form-control'
                      style={{ fontSize: '16px' }}
                      placeholder='請輸入電話號碼查詢'
                    />
                  </Form.Item>
                </div>
              </div>
              <div class='text-center mt-5'>
                <a
                  class='h6 btn btn-outline-primary rounded-pill px-5 py-3'
                  role='button'
                  href='#'
                  onClick={(e) => {
                    e.preventDefault()
                    this.formRef.current.submit()
                  }}>
                  {__('查詢維修進度', 'cec-plugin-stores')}
                </a>
              </div>
            </Form>
            <hr class='border-top border-gray my-5' />

            {this.state.isFetchData === true && (
              <Spin>
                <div
                  class='row justify-content-center'
                  style={{ minHeight: 200 }}>
                  <hr class='border-top border-gray my-5' />
                </div>
              </Spin>
            )}
            {_.isEmpty(listInfo) && this.state.isFetchData === false && (
              <div
                class='h4 row justify-content-center'
                style={{ minHeight: 200 }}>
                {__('查無此資料的訊息', 'cec-plugin-stores')}
              </div>
            )}

            {!_.isEmpty(listInfo) && (
              <Fragment>
                <div class='row justify-content-center'>
                  <div class='col-4'>
                    <p class='h5 text-font fw-300 mb-4'>
                      {__('選擇維修紀錄以查看進度', 'cec-plugin-stores')}
                    </p>
                    <div
                      class='nav flex-column nav-pills outline-tab'
                      id='v-pills-tab'
                      role='tablist'
                      aria-orientation='vertical'>
                      <a
                        class='nav-link active'
                        id={`v-pills-tab-0`}
                        data-toggle='pill'
                        href={`#v-pills-0`}
                        role='tab'
                        aria-controls={`v-pills-0`}
                        aria-selected='false'>
                        <div class='d-flex justify-content-between mb-2'>
                          <p class='p mb-0'>
                            {__('客戶姓名', 'cec-plugin-stores')}：
                            {listInfo[0].CUSTOMERNAME}{' '}
                            {__('先生/小姐', 'cec-plugin-stores')}
                          </p>
                        </div>
                        <p class='p mb-2'>
                          {__('單號', 'cec-plugin-stores')}：
                          {listInfo[0].FORMNUMBER}
                        </p>
                        <p class='p mb-2'>{listInfo[0].FIXITEM}</p>
                        <p class='p mb-0'>{listInfo[0].STORE}</p>
                        {listInfo[0].REMARK2 && (
                          <p class='p mb-0'>
                            {__('備註', 'cec-plugin-stores')}：
                            {listInfo[0].REMARK2}
                          </p>
                        )}
                      </a>
                      {_.map(listInfo, (item, idx) => {
                        if (idx > 0) {
                          return (
                            <a
                              class='nav-link'
                              id={`v-pills-tab-${idx}`}
                              data-toggle='pill'
                              href={`#v-pills-${idx}`}
                              role='tab'
                              aria-controls={`v-pills-${idx}`}
                              aria-selected='false'>
                              <div class='d-flex justify-content-between mb-2'>
                                <p class='p mb-0'>
                                  {__('客戶姓名', 'cec-plugin-stores')}：
                                  {item.CUSTOMERNAME}{' '}
                                  {__('先生/小姐', 'cec-plugin-stores')}
                                </p>
                              </div>
                              <p class='p mb-2'>
                                {__('單號', 'cec-plugin-stores')}：
                                {item.FORMNUMBER}
                              </p>
                              <p class='p mb-2'>{item.FIXITEM}</p>
                              <p class='p mb-0'>{item.STORE}</p>
                              {item.REMARK2 && (
                                <p class='p mb-0'>
                                  {__('備註', 'cec-plugin-stores')}：
                                  {item.REMARK2}
                                </p>
                              )}
                            </a>
                          )
                        }
                      })}
                    </div>
                  </div>
                  <div class='col-auto'>
                    <div class='tab-content' id='v-pills-tabContent'>
                      <div
                        class='tab-pane fade active show '
                        id={`v-pills-0`}
                        role='tabpanel'
                        aria-labelledby={`#v-pills-tab-0`}>
                        <div class='maintain-timeline'>
                          <ol>
                            {_.map(
                              [
                                {
                                  step: 1,
                                  icon: 'icon-shipping',
                                  name: '商品已收件',
                                },
                                {
                                  step: 2,
                                  icon: 'icon-repair',
                                  name: '商品送件維修',
                                },
                                {
                                  step: 3,
                                  icon: 'icon-store',
                                  name: '商品已完修\n回店途中',
                                },
                                {
                                  step: 4,
                                  icon: 'icon-ready',
                                  name: '請顧客至原店取件',
                                },
                                {
                                  step: 5,
                                  icon: 'icon-customer',
                                  name: '顧客已取件',
                                },
                              ],
                              (stepInfo) => (
                                <li
                                  className={classnames(
                                    stepInfo.step <= listInfo[0].FIXPROGRESS &&
                                      listInfo[0].FIXPROGRESS < '6' &&
                                      'active',
                                    stepInfo.step == listInfo[0].FIXPROGRESS &&
                                      'is-active',
                                  )}>
                                  <div class='item'>
                                    <div class='icon'>
                                      <i className={stepInfo.icon} />
                                    </div>
                                    <span class='dot' />
                                    <div class='text'>
                                      <p>{stringToBr(stepInfo.name)}</p>
                                    </div>
                                  </div>
                                </li>
                              ),
                            )}
                          </ol>
                        </div>
                      </div>
                      {_.map(listInfo, (item, idx) => {
                        if (idx > 0) {
                          return (
                            <div
                              class='tab-pane fade '
                              id={`v-pills-${idx}`}
                              role='tabpanel'
                              aria-labelledby={`#v-pills-tab-${idx}`}>
                              <div class='maintain-timeline'>
                                <ol>
                                  {_.map(
                                    [
                                      {
                                        step: 1,
                                        icon: 'icon-shipping',
                                        name: '商品已收件',
                                      },
                                      {
                                        step: 2,
                                        icon: 'icon-repair',
                                        name: '商品送件維修',
                                      },
                                      {
                                        step: 3,
                                        icon: 'icon-store',
                                        name: '商品已完修\n回店途中',
                                      },
                                      {
                                        step: 4,
                                        icon: 'icon-ready',
                                        name: '請顧客至原店取件',
                                      },
                                      {
                                        step: 5,
                                        icon: 'icon-customer',
                                        name: '顧客已取件',
                                      },
                                    ],
                                    (stepInfo) => (
                                      <li
                                        className={classnames(
                                          stepInfo.step <=
                                            listInfo[0].FIXPROGRESS &&
                                            listInfo[0].FIXPROGRESS < '6' &&
                                            'active',
                                          stepInfo.step == item.FIXPROGRESS &&
                                            'is-active',
                                        )}>
                                        <div class='item'>
                                          <div class='icon'>
                                            <i className={stepInfo.icon} />
                                          </div>
                                          <span class='dot' />
                                          <div class='text'>
                                            <p>{stringToBr(stepInfo.name)}</p>
                                          </div>
                                        </div>
                                      </li>
                                    ),
                                  )}
                                </ol>
                              </div>
                            </div>
                          )
                        }
                      })}
                    </div>
                  </div>
                </div>
                <hr class='border-top border-gray my-5' />
                <ol class='list-unstyled text-center text-muted mb-0'>
                  <li class='p mb-0'>
                    {__(
                      '1. 送修時間約二至三週工作天，實際完成日會因廠商維修、待料等因素有所變動，完修後會主動以簡訊與您聯繫前來領取維修品。',
                      'cec-plugin-stores',
                    )}{' '}
                  </li>
                  <li class='p mb-0'>
                    {__(
                      '2. 請在接獲萬家福通知領回維修品後立即前來領取。如逾期三個月，恕不負保管責任。',
                      'cec-plugin-stores',
                    )}{' '}
                  </li>
                  <li class='p mb-0'>
                    {__(
                      '3.廠商費用報價經台端確認後礙難更改，有效保固證明(有蓋店章)或發票請於報價前提供。',
                      'cec-plugin-stores',
                    )}{' '}
                  </li>
                  <li class='p mb-0'>
                    {__(
                      '4.商品故障原因依原廠判定，本公司不做判定。',
                      'cec-plugin-stores',
                    )}
                  </li>
                </ol>
                <hr class='border-top border-gray my-5' />
              </Fragment>
            )}
            <h4 class='heading-title justify-content-center'>
              {__('需要進一步協助？', 'cec-plugin-stores')}
            </h4>
            <div class='my-5 text-center'>
              <div class='pb-5'>
                <p class='p text-muted mb-2' style={{ fontSize: '16px' }}>
                  {__('請在營業時間內撥打', 'cec-plugin-stores')}
                </p>
                <a
                  class='p fw-400 mb-0 text-primary'
                  style={{ fontSize: '16px' }}
                  role='button'
                  href={`${VC_CONFIG.INDEX_URL}/stores`}>
                  <u>{__('全國服務專線', 'cec-plugin-stores')}</u>
                </a>
              </div>
            </div>
          </div>
        </main>
      </Fragment>
    )
  }
}

// 編輯器
export class RepairInfoEditor extends Component {
  render() {
    return (
      <div className='vu-blocks-editor'>
        <div class='components-placeholder__label'>
          <span class='block-editor-block-icon'>
            <div class='dashicons dashicons-admin-tools' />
          </span>
          家電維修模組
        </div>
        <p>查詢維修進度、維修單、維修單內容</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/repair/repair-info.js